var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderRadiusFull = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3499 11.8C17.6259 11.8 17.8497 12.024 17.8499 12.3V17.3C17.8499 17.4455 17.7859 17.5748 17.6868 17.6662C17.6153 17.7538 17.5155 17.8176 17.4006 17.841L17.3 17.8508H12.3C12.024 17.8508 11.8002 17.6267 11.8 17.3508C11.8 17.0746 12.0239 16.8508 12.3 16.8508H16.8499V12.3C16.8501 12.024 17.0738 11.8 17.3499 11.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 11.8C2.97634 11.8 3.2002 12.0238 3.2002 12.3V16.8049H7.7002L7.80078 16.8146C8.0287 16.8612 8.2002 17.0632 8.2002 17.3049C8.19998 17.5463 8.02855 17.7476 7.80078 17.7941L7.7002 17.8049H2.7002C2.4242 17.8049 2.20044 17.5808 2.2002 17.3049C2.2002 17.2799 2.2035 17.2556 2.20703 17.2316C2.2035 17.2077 2.2002 17.1833 2.2002 17.1584V12.3C2.2002 12.0238 2.42405 11.8 2.7002 11.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80054 2.20978C8.02823 2.25646 8.19986 2.45853 8.19995 2.70001C8.19995 2.94155 8.02825 3.14353 7.80054 3.19025L7.69995 3.20001H3.19995V7.70001C3.19995 7.97599 2.97587 8.19975 2.69995 8.20001C2.42381 8.20001 2.19897 7.97615 2.19897 7.70001V2.70001C2.19907 2.42395 2.42387 2.20001 2.69995 2.20001H7.69995L7.80054 2.20978Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3528 2.21075C17.4261 2.22572 17.4923 2.25844 17.55 2.30157C17.6998 2.38794 17.802 2.5479 17.802 2.73322V7.70099C17.8018 7.9769 17.5779 8.2009 17.302 8.20099C17.026 8.20092 16.8022 7.97691 16.802 7.70099V3.20001H12.3C12.0239 3.20001 11.8 2.97615 11.8 2.70001C11.8002 2.42404 12.024 2.20001 12.3 2.20001H17.2522L17.3528 2.21075Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderRadiusFull);
export default ForwardRef;